// extracted by mini-css-extract-plugin
export var searchHeader = "_9w-0";
export var searchHeaderDark = "_9w-1";